import React from 'react';
import Mascot, { isMascotId } from './Mascot';

/**
 * Renders a player's avatar.
 * - If the avatar is a mascot id ('m0'..'m7'), renders the SVG mascot.
 * - Otherwise (legacy emoji string, single-letter initial, undefined),
 *   falls back to text — keeps older clients/replays from breaking.
 *
 * Visual frame is provided by the parent via className/style.
 */
function PlayerAvatar({ avatar, fallback, size = 36, style, className }) {
  if (isMascotId(avatar)) {
    return <Mascot id={avatar} size={size} style={style} className={className} />;
  }
  const text = avatar || fallback || '?';
  return (
    <span className={className} style={{ fontSize: Math.round(size * 0.62), lineHeight: 1, ...style }}>
      {text}
    </span>
  );
}

export default PlayerAvatar;
